<template>
  <div>
    <h3>{{ label }}</h3>
    <p>{{ hint }}</p>
    <AtTextField
      v-for="(textField, i) in vModel"
      :key="i"
      v-model="vModel[i]"
      label=""
      v-bind="$attrs"
    />
    <v-btn
      v-if="!$attrs.readonly"
      text
      color="primary"
      class="mb-3"
      :disabled="vModel ? vModel.includes('') : true"
      @click="vModel.push('')"
    >
      {{ $t('components.AtTextFieldGroup.add_more') }}
    </v-btn>
  </div>
</template>

<script>
import AtTextField from '../AtTextField/AtTextField.vue'

export default {
  name: 'AtTextFieldGroup',

  components: { AtTextField },

  props: {
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    }
  },
  computed: {
    vModel: {
      get () {
        return this.value
      },
      set (val, oldVal) {
        if (JSON.stringify(val) === JSON.stringify(oldVal)) return
        this.$emit('input', val)
      }
    }
  }
}
</script>
